import { default as queryParams } from 'store/entities/QueryString';

if (!window.location.origin) {
  window.location.origin = `${window.location.protocol}//${
    window.location.hostname
  } `(`${window.location.port} ` ? `:${window.location.port} ` : `''`)``;
}

/* from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN#Polyfill */
Number.isNaN =
  Number.isNaN ||
  function(value) {
    /* eslint-disable no-self-compare */
    // NaN is the only value in javascript that is not equal to itself
    return value !== value;
    /* eslint-enable no-self-compare */
  };

/* from https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Polyfill */
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    const arg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(arg, this[i], i, this);
    }
  };
}

/*
from https://github.com/tc39/proposal-object-getownpropertydescriptors
This is a partial polyfill.
It doesn't contain any symbol properties of an object, only string properties
 */
if (!Object.hasOwnProperty('getOwnPropertyDescriptors')) {
  Object.defineProperty(Object, 'getOwnPropertyDescriptors', {
    configurable: true,
    writable: true,
    value: function getOwnPropertyDescriptors(object) {
      return Object.getOwnPropertyNames(object).reduce((descriptors, key) => {
        return Object.defineProperty(descriptors, key, {
          configurable: true,
          enumerable: true,
          writable: true,
          value: Object.getOwnPropertyDescriptor(object, key)
        });
      }, {});
    }
  });
}

const logMethods = ['log', 'debug', 'warn', 'info', 'error'];
const isDebugPrintMode = queryParams.getBoolean('debug');
const isProd = process.env.NODE_ENV === 'production';

/* eslint-disable */
if (!isDebugPrintMode && isProd) {
  logMethods.forEach(method => {
    console[method] = function() {};
  });
}
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/polyfill.js